import axios from 'axios';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import { Navigation } from '@repo/types';
import API from '../endpoints';
import { getAccessToken } from '../utils/getAccessToken';

const accessToken = getAccessToken();

// 30 minutes frontend cache for navigation list query
const CACHE_TIME = 30 * 60 * 1000;

export const useNavigationsQuery = () => {
  return useQuery({
    queryKey: ['navigations'],
    queryFn: fetchNavigations,
    staleTime: !accessToken ? CACHE_TIME : undefined,
  });
};

const fetchNavigations: QueryFunction<Navigation, [string]> = async () => {
  const { data } = await axios.get<Navigation>(API.endpoints.navigations);
  return data;
};
